import { mixin, scope } from 'cssapi'
import { css } from 'styled-components'
import { randomNumberInRange } from '../../helpers/random'
import halftoneBackground from './halftoneBackground'

const comicHeader = api => () => {
  const rangeX = 25
  const rangeY = 13

  const leftShadowX = -randomNumberInRange(4, rangeX)
  const leftShadowY = -randomNumberInRange(3, rangeY)

  const rightShadowX = randomNumberInRange(4, rangeX)
  const rightShadowY = randomNumberInRange(3, rangeY)

  return css`
    position: relative;
    ${api({
      background: halftoneBackground(),
      padding: scope`1ru 2ru`,
      border: `4px solid c:text`,
    })};

    ::before {
      content: '';
      position: absolute;
      background: transparent;
      ${api({
        offset: 0,
        boxShadow: `${leftShadowX} ${leftShadowY} 0 0 c:backgroundInverted`,
      })};
    }

    ::after {
      content: '';
      position: absolute;
      z-index: -1;
      ${api({
        offset: `${rightShadowY} -${rightShadowX} -${rightShadowY} -${
          rightShadowY
        }`,
        background: `c:backgroundInverted`,
        boxShadow: `15 0 0 0 c:backgroundInverted`,
      })};

      transform: rotate(0.5deg);
      transform-origin: bottom left;
    }
  `
}

export default mixin(comicHeader)



// WEBPACK FOOTER //
// ./src/components/styles/mixins/comicHeader.js